import type { CalendarDate } from "../shared/calendar-date";
import { requireFinitePositive } from "../shared/validation";

export interface WeightEntry {
  readonly id: string;
  readonly date: CalendarDate;
  readonly kilograms: number;
  readonly recordedAt: string;
  readonly updatedAt: string;
}

export function createWeightEntry(entry: WeightEntry): WeightEntry {
  requireFinitePositive(entry.kilograms, "Weight");
  return entry;
}
